import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  Chip,
  Dialog,
  //DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
  FormControl,
  FormHelperText,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography,
  FormLabel,
  Select,
  MenuItem,
  Tab,
  Tabs,
  Tooltip
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import ArrowUpwordIcon from '@mui/icons-material/ArrowUpward';
import NumbersIcon from '@mui/icons-material/Numbers';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import HomeIcon from '@mui/icons-material/Home';
import CustomTabPanel from "../widgets/CustomTabPanel";
import { DataGridPro as DataGrid } from "@mui/x-data-grid-pro";
import {
  updateShiftsAsync,
  updateShift,
  addShift,
  deleteShift,
} from "../../redux/slices/shiftsSlice";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ConfirmDialog from "../../components/widgets/ConfirmDialog"
import { MuiTelInput } from "mui-tel-input";
import { datetimeFormat, formatBooleanColumns, formatFault, formatVehicleBrand, formatVehicleModel, renderStatus } from "../../utils/utils";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import LocalAutocomplete from "../widgets/LocalAutocomplete";
import { unassignTaskAsync, updatePatrolAsync, suspendPatrolAsync } from "../../redux/slices/patrolsSlice";
import { getRostersAsync } from "../../redux/slices/shiftsSlice";
import { assignTaskAsync } from "../../redux/slices/patrolsSlice";
import { Link } from "react-router-dom";
import AuditGrid from "../grids/auditGrid";
import { setNotification } from '../../redux/slices/notificationSlice';
import { CALL_HANDLER, CONTROL_TOWER } from "../../utils/config";

// temporary formatting to standardize phone numbers until backend data is available
const normalizePhone = (rawPhone) => {
  const digitsOnly = rawPhone?.replace(/\D/g, '');
  if (digitsOnly?.startsWith('0')) {
    return '+' + digitsOnly.slice(1);
  }
  if (digitsOnly?.startsWith('00')) {
    return '+' + digitsOnly.slice(2);
  }
  return '+' + digitsOnly;
};

export default function PatrolWithShifts({ open, onClose, entity }) {
  
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const dispatch = useDispatch();
  const [shiftPaginationModel, setShiftPaginationModel] = useState({page: 0, pageSize: 20});
  const shiftsData = useSelector((state) => state.shifts);
  const [selectedRoster, setSelectedRoster] = useState(null);
  const [selectedShift, setSelectedShift] = useState(null);
  const [selectedSuspendDate, setSelectedsuspendDate] = useState(dayjs());
  //const [updatedSuspendDate, setUpdatedSuspendDate] = useState(null);
  //const isSuspendUpdateDisabled = !selectedSuspendDate || selectedSuspendDate?.isSame(updatedSuspendDate);
  const [pageSize, setPageSize] = useState(5);
  const [formData, setFormData] = useState({ phoneNumber: entity?.phoneNumber || "" });
  const [phoneError, setPhoneError] = useState("");
  const constants = useSelector(state => state.constants.data);
  const livePatrol = useSelector(state => state.patrols.allPatrols.find(p => p.id == entity.id));
  const [newAssignment, setNewAssignment] = useState('');
  const [taskTypes, setTaskTypes] = useState([]);
  const [resourceTypes, setResourceTypes] = useState([]);
  const [tabsValue, setTabsValue] = useState(0);
  const [shiftEditMode, setShiftEditMode] = useState(false);
  const [shifts, setShifts] = useState([]);
  const assignments = useSelector((state) =>
    state.tasks.allTasks.filter(item => livePatrol.assignedTasks?.includes(item.id))
  ) || [];
  const [confirmDelete, setConfirmDelete] = useState({
    open: false,
    id: null,
  });
  const [resourceType, setResourceType] = useState([]);
  const [confirmDeassign, setConfirmDeassign] = useState({
    open: false,
    patrolId: null,
    taskId: null
  });
  const [shiftsDirty, setShiftsDirty] = useState(false);
  const [rosterDirty, setRosterDirty] = useState(false);
  const [confirmMainClose, setConfirmMainSave] = useState(false);
  const { rosters } = shiftsData;
  const { roles } = useSelector((state) => state.auth) || [];

  const shiftFormRef = useRef(null);

  useEffect(() => {
    if (selectedShift && shiftFormRef.current) {
      shiftFormRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }, [selectedShift]);

  const fieldPermissions = {
    phoneNumber: roles.includes(CALL_HANDLER) && !roles.includes(CONTROL_TOWER) ? false : true,
    newAssignment: roles.includes(CALL_HANDLER) && !roles.includes(CONTROL_TOWER) ? false : true,
    setUVOR: roles.includes(CALL_HANDLER) && !roles.includes(CONTROL_TOWER) ? false : true,
    shiftMgmt: roles.includes(CALL_HANDLER) && !roles.includes(CONTROL_TOWER) ? false : true,
  }

  const handleSelectRoster = (value) => {
    setSelectedRoster(value);
  }

  const onConfirmClose = () => {
    if (!rosterDirty) {
      onClose();
    } else {
      setConfirmMainSave(true);
    }
  }

  const handleConfirmSaveDialog = () => {
    setRosterDirty(false);
    onClose();
  }

  const handleCancelSaveDialog = () => {
    setConfirmMainSave(false);
  }

  useEffect(() => {
    if (selectedRoster) {
      setShifts(rosters.find(r => r.id == selectedRoster).duties);
    }

  }, [selectedRoster, rosters]);

  useEffect(() => {
    handlePhoneChange(livePatrol.phoneNumber);
    setSelectedsuspendDate(livePatrol.suspendUntil);
    setResourceType(livePatrol.resourceType.map(id => constants.resourceTypes.find(t => t.id == id)));
  }, [livePatrol]);

  useEffect(() => {
    setTaskTypes(constants.taskType);
    setResourceTypes(constants.resourceTypes);
    if (livePatrol.manualUvorUntil) {
      const parsed = dayjs.utc(livePatrol.manualUvorUntil).tz('Europe/London');
      const isValidAndRecent = parsed.isValid() && parsed.isAfter('2000-01-01');
      setSelectedsuspendDate(isValidAndRecent ? parsed : dayjs());
    } else {
      setSelectedsuspendDate(dayjs());
    }
    if(livePatrol.id) {
      dispatch(getRostersAsync(livePatrol.id));
    }
  }, []);

  const handlePhoneChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      phoneNumber: value,
    }));

    if (!value || value.length < 6) {
      setPhoneError("Please enter a valid phone number.");
    } else {
      setPhoneError("");
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabsValue(newValue);
  }

  const handlePatrolUpdate = async () => {
    try {

      const resp = await dispatch(updatePatrolAsync({
        ...livePatrol,
        //phoneNumber: formData.phoneNumber.replace('+', '').replace(/\s/g, ""),
        phoneNumber: formData.phoneNumber.replace(/\s/g, ""),
        resourceType: resourceType.map(type => type.id * 1),
        // status: {
        //   id: 49,
        //   code: "BASE",
        //   name: "BASE"
        // }
      })).unwrap();

      if (resp.status == 200 || resp.status == 204) {
        dispatch(
          setNotification({ severity: 'success', message: 'Patrol info updated.' })
        );
        dispatch({
          type: 'patrols/updatePatrol',
          payload: {
            ...livePatrol,
            phoneNumber: formData.phoneNumber.replace('+', '').replace(/\s/g, ""),
            resourceType: resourceType.map(type => type.id * 1),
          }
        });
      }
    } catch (error) {
      dispatch(
        setNotification({ severity: 'error', message: 'Patrol update error: ' + error.message })
      );
    }
  };

  const handleAssignPatrol = async () => {

    try {
      const resp = await dispatch(assignTaskAsync({
        taskId: newAssignment, assignedPatrol: livePatrol.id
      })).unwrap();

      if (resp.status == 200 || resp.status == 204) {
        dispatch(
          setNotification({ severity: 'success', message: 'Task assigned.' })
        );
        dispatch(
          {
            type: 'patrols/assignTask',
            payload: {
              patrolId: livePatrol.id,
              taskId: newAssignment
            },
          });
      }
    } catch (error) {
      dispatch(
        setNotification({ severity: 'error', message: 'Task assingment error: ' + error.message })
      );
    }
  }

  const validateShift = () => {
    if (shiftsDirty && (!selectedShift.startTime || !selectedShift.finishTime || !selectedShift.dutyTypeId || !selectedShift.payTypeCode)) {
      return false;
    } else {
      return true;
    }
  }

  const handleAddShift = () => {
    setShiftEditMode(false);
    const newShift = {

      dutyTypeId: "",
      payTypeCode: "",
      startTime: new Date().toISOString(),
      finishTime: new Date().toISOString(),
      rosterArea: ''
    };
    setSelectedShift(newShift);
  };

  const handleSaveShiftInfo = async () => {
    if (!validateShift()) {
      dispatch(
        setNotification({ severity: 'error', message: 'Duty Type & Pay Type are mandatory.' })
      );
      return;
    }

    setShiftsDirty(true);

    if (shiftEditMode) {
      setRosterDirty(true);
      const st = constants.dutyTypes.find(d => d.id == selectedShift.dutyTypeId);
      const pt = constants.payTypes.find(d => d.code == selectedShift.payTypeCode);
      dispatch(updateShift({
        ...selectedShift, 
        dutyTypeCode: st?.code, 
        payTypeName: pt?.name, 
        rosterId: selectedRoster, 
        patrolId: livePatrol.id
      }));
      dispatch(
        setNotification({ severity: 'success', message: 'Shift updates saved.' })
      );
    } else {
      setRosterDirty(true); 
      if(!selectedShift.dutyTypeId || !selectedShift.payTypeCode) {
        dispatch(
          setNotification({ severity: 'error', message: 'Duty Type & Pay Type are mandatory.' })
        );
        return;
      }
      const st = constants.dutyTypes.find(d => d.id == selectedShift.dutyTypeId);
      const pt = constants.payTypes.find(d => d.code == selectedShift.payTypeCode);
      dispatch(addShift({
        ...selectedShift,
        rosterId: selectedRoster,
        patrolId: livePatrol.id,
        payTypeName: pt?.name,
        dutyTypeCode: st?.code
      }));
      dispatch(
        setNotification({ severity: 'success', message: 'New shift added to the roster.' })
      );
    }
  }

  const handleSaveShifts = async () => {
    if (!validateShift()) {
      return;
    }
    // send the whole shift array from here instead of composing it in the reducer
    try {
      const updateResp = await dispatch(updateShiftsAsync({ rosterId: selectedRoster, patrolId: livePatrol.id })).unwrap();
      setShiftsDirty(false);
      if (updateResp.status == 200 || updateResp.status == 204) {
        dispatch(
          setNotification({ severity: 'success', message: 'Roster shifts updated.' })
        );
      }
    } catch (error) {
      dispatch(
        setNotification({ severity: 'error', message: 'Shifts updating error: ' + error.message })
      );
    }
  }

  const handleDeleteShift = (id) => {
    setConfirmDelete({
      open: true,
      id,
      message: "Are you sure you want to delete this shift?",
    });
  };

  const handleCloseDeleteDialog = () => {
    setConfirmDelete({ open: false, id: null });
  };

  const handleCloseDeassignDialog = () => {
    setConfirmDeassign({ open: false, id: null });
  };

  const handleConfirmDelete = async () => {
    if (confirmDelete.id !== null) {
      setRosterDirty(true);
      dispatch(deleteShift({
        rosterId: selectedRoster,
        id: confirmDelete.id
      }));
      dispatch(
        setNotification({ severity: 'success', message: 'Shift deleted.' })
      );
    }
    handleCloseDeleteDialog();
  };

  const handleConfirmDeassign = async () => {
    if (confirmDeassign.id !== null) {
      if (assignments.find(t => t.id == confirmDeassign.taskId)?.statusId == 16) {
        dispatch(
          setNotification({ severity: 'error', message: 'Task cannot be deassigned when status is in ARVD.' })
        );
        handleCloseDeassignDialog();
        return false;
      }
      try {
        const resp = await dispatch(unassignTaskAsync({
          patrolId: confirmDeassign.patrolId,
          taskId: confirmDeassign.taskId
        })).unwrap();

        if (resp.status == 200 || resp.status == 204) {
          dispatch(
            setNotification({ severity: 'success', message: 'Task deassigned.' })
          );

          dispatch(
            {
              type: 'patrols/unassignTask',
              payload: {
                patrolId: confirmDeassign.patrolId,
                taskId: confirmDeassign.taskId
              },
            }
          );
        }
      }
      catch (error) {
        dispatch(
          setNotification({ severity: 'error', message: 'Task deassingment error: ' + error.message })
        );
      }
    }
    handleCloseDeassignDialog();
  };

  const handleRemoveAssignment = (patrolId, taskId) => {
    setConfirmDeassign({
      open: true,
      patrolId,
      taskId,
      message: "Are you sure you want to unassign this task?",
    });
  }

  const handleEditShiftInline = (/*id, field, value*/) => {
    // const updatedShift = shifts.find((shift) => shift.id === id);
    // if (updatedShift) {
    //   dispatch(updateShift({ ...updatedShift, [field]: value }));
    // }
  };

  const handleShiftDetailChange = (e) => {
    let { name, value } = e.target;
    const updatedShift = { ...selectedShift, [name]: value };
    setSelectedShift(updatedShift);
    //dispatch(updateShift(updatedShift));
  };

  const handleSuspendUpdate = async (patrolId) => {
    if (!patrolId || !selectedSuspendDate) return;

    try {
      await dispatch(
        suspendPatrolAsync({
          patrolId,
          suspendUntil: new Date(selectedSuspendDate).toISOString()
        })).unwrap();

      dispatch(
        setNotification({ severity: 'success', message: 'Patrol suspend updated.' })
      );
    } catch (error) {
      dispatch(
        setNotification({ severity: 'error', message: error?.SuspendUntil?.[0] || 'Failed to suspend patrol.' })
      );
    }
  }

  const handleTypeChange = (event) => {
    const {
      target: { value },
    } = event;
    setResourceType(typeof value === 'string' ? [] : value);
  };

  const renderType = (typeId, taskTypes) => {
    const type = taskTypes?.find(t => t.id == typeId);
    return type && <Tooltip title={type.code} arrow>
      <Chip label={type?.code} size="small" />
    </Tooltip>
  }

  const assignmentsColumns = [
    {
      field: "id",
      headerName: "ID",
      flex: 0.5
    },
    {
      field: 'typeId',
      headerName: 'Type',
      description: 'Type',
      flex: 0.8,
      minWidth: 50,
      renderCell: (params) => renderType(params.row.typeId, taskTypes),
      valueGetter: (value) => {
        const type = taskTypes.find(t => t.id === value);
        return type?.name || '';
      },
    },
    {
      field: "customerName",
      headerName: "Customer Name",
      flex: 1,
    },
    {
      field: "vehicleMakeId",
      headerName: "V. Brand",
      flex: 1,
      valueGetter: value => formatVehicleBrand(value, constants.vehicleMakes)
    },
    {
      field: "vehicleModelId",
      headerName: "V. Model",
      flex: 1,
      valueGetter: value => formatVehicleModel(value, constants.vehicleModels)
    },
    {
      field: 'priority',
      headerName: '⚠️',
      headeralign: 'left',
      description: 'Priority',
      align: 'left',
      flex: 1,
      maxWidth: 50,
      valueGetter: value => formatBooleanColumns(value),
    },
    {
      field: 'homeStart',
      headerName: '🏠',
      headeralign: 'left',
      description: 'HomeStart',
      align: 'left',
      flex: 1,
      maxWidth: 50,
      valueGetter: value => formatBooleanColumns(value),
    },
    {
      field: 'requiresIntervention',
      description: 'Requires Intervention',
      headerName: '🧑‍🔧',
      headeralign: 'left',
      align: 'left',
      flex: 1,
      maxWidth: 50,
      valueGetter: value => formatBooleanColumns(value),
    },
    {
      field: "faultId",
      headerName: "Fault",
      flex: 1,
      valueGetter: value => formatFault(value, constants.vehicleFaults)
    },
    {
      field: "statusId",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => renderStatus(params.value, constants.taskStatuses),
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      sortable: false,
      headerAlign: "right",
      align: "right",
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            mt: 0.75,
          }}
        >
          {Boolean(fieldPermissions.newAssignment) && <Button
            variant="contained"
            size="small"
            color="error"
            disabled={ assignments.find(a => a.id == params.row.id).statusId == 16 ? true : false }
            onClick={() => handleRemoveAssignment(entity.id, params.row.id)}
          >
            Deassign
          </Button>}
        </Box>
      ),
    },
  ];

  const formatPayType = (value) => {
    return constants.payTypes.find(t => t.code.toLowerCase() == value.toLowerCase()).name;
  }

  const parseToMs = (v) => {
    return v ? dayjs.utc(v, datetimeFormat).valueOf() : Number.NEGATIVE_INFINITY;
  };
   
  const dateSortComparator = (v1, v2) => {
    return parseToMs(v1) - parseToMs(v2);
  };
   
  const columns = [
    { field: "id", headerName: "Shift ID", flex: 0.5, editable: true },
    {
      field: "dutyTypeCode",
      headerName: "Shift Type",
      flex: 0.5,
    },
    {
      field: "startTime",
      headerName: "Start Time",
      flex: 1,
      //renderCell: (params) => dayjs(params.value).format(datetimeFormat),
      valueGetter: value => dayjs.utc(value).format(datetimeFormat),
      sortComparator: dateSortComparator
      
    },
    {
      field: "finishTime",
      headerName: "End Time",
      flex: 1,
      valueGetter: value => dayjs.utc(value).format(datetimeFormat),
      //renderCell: (params) => dayjs(params.value).format(datetimeFormat),
      sortComparator: dateSortComparator
    },
    {
      field: "payTypeCode",
      headerName: "Pay Type",
      flex: 0.5,
      renderCell: (params) => formatPayType(params.value),
    },
    {
      field: "rosterArea",
      headerName: "Roster Area",
      flex: 0.5,
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      sortable: false,
      headerAlign: "right",
      align: "right",
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            mt: 0.75,
          }}
        >
          {Boolean(fieldPermissions.shiftMgmt) &&
            <>
              <Button
                variant="outlined"
                size="small"
                sx={{ mr: 0.5 }}
                onClick={() => { setShiftEditMode(true); return setSelectedShift(params.row) }}
              >
                Edit
              </Button>
              <Button
                variant="contained"
                size="small"
                color="error"
                onClick={() => handleDeleteShift(params.row.id)}
              >
                Delete
              </Button>
            </>}
        </Box>
      ),
    },
  ];
  const patrolId = livePatrol ? ` (Id: ${livePatrol.id})` : '';
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogContent>
        <Tabs sx={{ width: '80%' }} value={tabsValue} onChange={handleTabChange}>
          <Tab label={`Patrol Details${patrolId}`} key="tab1" />
          <Tab label="Audit Patrol" key="tab2" />
        </Tabs>
        <CustomTabPanel index={0} value={tabsValue}>

          <IconButton
            onClick={onClose}
            sx={{ position: "absolute", top: 8, right: 10 }}>
            <CloseIcon />
          </IconButton>

          <Typography variant="h6">Manage Patrol Info - <Link to={`/patrol-ui/patrolId/${livePatrol.id}`}>{livePatrol.fullName} - {livePatrol.callsign}</Link></Typography>
          <Box sx={{ display: "flex", gap: 2, width: "100%", mb: 1 }}>
            <Box sx={{ width: "50%" }}>
              <Box sx={{ mb: 1, mt: 2, top: 2 }}>
                <Box>
                  <FormControl fullWidth sx={{ mt: 3 }}>
                    <MuiTelInput
                      defaultCountry="GB"
                      forceCallingCode
                      label='Phone No'
                      // @TODO fix disabled sending undefined
                      //disabled={!fieldPermissions.phoneNumber}
                      value={normalizePhone(formData.phoneNumber)}
                      onChange={handlePhoneChange}
                    />
                    {phoneError && <FormHelperText error>{phoneError}</FormHelperText>}
                  </FormControl>
                </Box>
                <Box sx={{ mt: 2 }}>
                  <FormControl fullWidth sx={{ mr: 0 }}>
                    <FormLabel>Resource Type</FormLabel>
                    <Select
                      label="Resource Type"
                      multiple
                      disabled={!fieldPermissions.newAssignment}
                      value={resourceType}
                      onChange={handleTypeChange}
                      renderValue={(selected) => {
                        return (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                          {selected.map((value) => {
                            if (resourceType.length)
                              return (
                                <Chip key={value?.id} label={value?.code} />
                              )
                          })}
                        </Box>
                      )}}
                      fullWidth
                    >
                      {resourceTypes?.map(type =>
                        <MenuItem
                          selected={resourceType.some(item => item?.id == type.id)}
                          key={type.key}
                          value={type}>
                          {type.code}
                        </MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </Box>
              </Box>
              <Box sx={{ mb: 3, display: 'flex', justifyContent: "end" }}>
                <Button onClick={handlePatrolUpdate} variant="contained" color="warning" disabled={!fieldPermissions.newAssignment}
                  sx={{ color: '#ffffff', mt: 1.5 }}>
                  Save
                </Button>
              </Box>

              <Divider sx={{ mb: 4 }} />

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box sx={{ display: "flex", justifyContent: 'space-between', mb: 6, mt: 2, top: 2 }}>
                  <DateTimePicker
                    ampm={false}
                    format={datetimeFormat}
                    label={!fieldPermissions.setUVOR ? "UVOR until:" : "Set as UVOR until: "}
                    disabled={!fieldPermissions.setUVOR}
                    value={dayjs(selectedSuspendDate)}
                    onChange={(newValue) => { setSelectedsuspendDate(newValue) }}
                    slotProps={{ textField: { variant: "outlined" } }}
                    sx={{ pt: 1, mr: 1 }}
                  />
                  {Boolean(fieldPermissions.setUVOR) && <Button
                    onClick={() => handleSuspendUpdate(entity.id)}
                    variant="contained"
                    color="warning"
                    // disabled={isSuspendUpdateDisabled}
                    sx={{
                      color: '#ffffff',
                      mt: '8px'
                    }}>
                    Update
                  </Button>}
                </Box>
              </LocalizationProvider>
            </Box>
            <Box sx={{ width: "50%" }}>
              <Card sx={{ width: '100%', maxWidth: 360, bgcolor: '#ffffff' }}>
                <List >
                  <ListItem disablePadding>
                    <ListItemIcon>
                      <PersonIcon sx={{ mt: "5px" }} />
                      <ListItemText sx={{ ml: 1, color: '#000' }} primary={`Name: ${livePatrol.fullName}`} />
                    </ListItemIcon>
                  </ListItem>
                  <ListItem disablePadding>
                    <ListItemIcon>
                      <NumbersIcon sx={{ mt: "5px" }} />
                      <ListItemText sx={{ ml: 1, color: '#000' }} primary={`Reg No: ${livePatrol.vehicleVrn}`} />
                    </ListItemIcon>
                  </ListItem>
                  <ListItem disablePadding>
                    <ListItemIcon>
                      <HeadsetMicIcon sx={{ mt: "5px" }} />
                      <ListItemText sx={{ ml: 1, color: '#000' }} primary={`Call Sign: ${livePatrol.callsign}`} />
                    </ListItemIcon>
                  </ListItem>
                  <ListItem disablePadding>
                    <ListItemIcon>
                      <AirportShuttleIcon sx={{ mt: "5px" }} />
                      <ListItemText sx={{ ml: 1, color: '#000' }} primary={`Type: ${livePatrol.resourceType.map(t => ` ${constants.resourceTypes.find(type => type.id == t)?.code}`)}`} />
                    </ListItemIcon>
                  </ListItem>
                  <ListItem disablePadding>
                    <ListItemIcon>
                      <AutoModeIcon sx={{ mt: "5px" }} />
                      <ListItemText sx={{ ml: 1, color: '#000' }} primary={`Status: ${livePatrol.status.code}`} title={`Status: ${livePatrol.status.name}`} />
                    </ListItemIcon>
                  </ListItem>
                  <ListItem disablePadding>
                    <ListItemIcon>
                      <HomeIcon sx={{ mt: "5px" }} />
                      <ListItemText sx={{ ml: 1, color: '#000' }} primary={livePatrol.baseLocation?.lat && livePatrol.baseLocation?.lng ? (
                        <> Home Location: <a href={`https://maps.google.com/?q=${livePatrol.baseLocation?.lat},${livePatrol.baseLocation?.lng}`} title="Open Map" target="_blank" underline="hover"> Open Map </a></>) : (
                        'Home Location: N/A'
                      )} />
                    </ListItemIcon>
                  </ListItem>
                  <ListItem disablePadding>
                    <ListItemIcon>
                      <ArrowUpwordIcon sx={{ mt: "5px" }} />
                      <ListItemText sx={{ ml: 1, color: '#000' }} primary={`Line Manager: ${livePatrol.managerName ?? ''}`} />
                    </ListItemIcon>
                  </ListItem>
                </List>
              </Card>
            </Box>
          </Box>

          <Divider sx={{ mb: 2 }} />

          <Typography variant="h5" sx={{ mb: 2 }}>Manage Patrol Assignments</Typography>

          <Box sx={{ display: "flex", mb: 6, mt: 2, top: 2 }}>
            <FormControl sx={{ mr: 3, width: '50%' }}>
              <FormLabel required sx={{ mb: '-8px', '& .MuiFormLabel-asterisk': { color: 'red' } }}>Assign a Task</FormLabel>
              <LocalAutocomplete
                readOnly={!fieldPermissions.newAssignment}
                placeholder="Task ID"
                list="tasks"
                showLabel={false}
                labelField={["id", "customerName"]}
                name="newAssignment"
                onChange={(value) => {
                  if(fieldPermissions.newAssignment) {
                    setNewAssignment(value);
                  }
                }}
              //ref={ref} 
              />

            </FormControl>
            <Button onClick={handleAssignPatrol} variant="contained" color="warning"
              disabled={!fieldPermissions.newAssignment}
              sx={{
                color: '#ffffff',
                mt: '25px'
              }}>
              Save
            </Button>
          </Box>

          {taskTypes && <DataGrid
            rows={assignments || {}}
            columns={assignmentsColumns}
            pageSize={pageSize}
            onPageSizeChange={(newSize) => setPageSize(newSize)}
            pagination
            disableSelectionOnClick
          />}


          <Divider sx={{ mb: 2 }} />

          <Typography variant="h5" sx={{ mb: 2 }}>Manage Patrol Shifts</Typography>

          <Box sx={{ width: '70%' }}>
            <FormLabel sx={{ mb: '-8px' }}>Rosters</FormLabel>
            {rosters && !rosters.length && <p>No rosters for this patrol.</p>}
            {rosters && rosters.length && <Select onChange={(e) => { handleSelectRoster(e.target.value) }} label="Rosters" sx={{ mb: 2 }} fullWidth >
              {rosters?.length && rosters.map((roster) => (
                <MenuItem key={roster.id} value={roster.id}>
                  {`Start: ${dayjs(roster.effectiveDate).format(datetimeFormat)} / End: ${dayjs(roster.ineffectiveDate).format(datetimeFormat)}`}
                </MenuItem>
              ))}
            </Select>}
          </Box>

          {selectedRoster && <>
            <Box display="flex" justifyContent="flex-end" mb={2}>
              {Boolean(fieldPermissions.shiftMgmt) &&
                <Button
                  variant="contained"
                  color="warning"
                  onClick={handleAddShift}
                  sx={{
                    color: '#ffffff'
                  }}
                >
                  Add Shift
                </Button>
              }
            </Box>
            <DataGrid
              rows={shifts || {}}
              columns={columns}
              initialState={{
                sorting: { sortModel: [{ field: 'startTime', direction: 'asc' }] }
              }}
              pagination
              paginationModel= {shiftPaginationModel}
              onPaginationModelChange={setShiftPaginationModel}
              pageSizeOptions={[10, 20, 50]}
              getRowId={(row) => row.id}
              pageSize={pageSize}
              onPageSizeChange={(newSize) => setPageSize(newSize)}
              onCellEditCommit={(params) =>
                handleEditShiftInline(params.id, params.field, params.value)
              }
              disableSelectionOnClick
            />
          </>}
          {selectedShift != null && (
            <Box ref={shiftFormRef} mt={3} p={2} border="1px solid #ccc" borderRadius={2}>
              <h3>Shift Details</h3>
              <Box
                sx={{ mb: 5, display: 'flex', flexDirection: 'row' }}
              >
                <Box sx={{ mr: 2 }}>
                  <FormLabel>Shift Type</FormLabel>
                  <Select value={selectedShift?.dutyTypeId} name='dutyTypeId' label="Shift Type" fullWidth onChange={handleShiftDetailChange} >
                    {constants.dutyTypes?.length && constants.dutyTypes.map((type) => (
                      <MenuItem key={type.id} value={type.id}>
                        {type.code}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
                <Box>
                  <FormLabel>Pay Type</FormLabel>
                  <Select value={selectedShift?.payTypeCode} name='payTypeCode' label="Pay Type" fullWidth onChange={handleShiftDetailChange} >
                    {constants.payTypes?.length && constants.payTypes.map((type) => (
                      <MenuItem key={type.code} value={type.code}>
                        {type.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Box>


              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  label="Start Time"
                  name='startTime'
                  format={datetimeFormat}
                  value={selectedShift?.startTime ? dayjs(selectedShift?.startTime) : null}
                  onChange={(newValue) => {
                    setSelectedShift({
                      ...selectedShift,
                      startTime: newValue ? newValue.format('YYYY-MM-DDTHH:mm:ss') : null
                    });
                  }}
                  slotProps={{ textField: { variant: "outlined" } }}
                  sx={{ pt: 1, mr: 1 }}
                />

                <DateTimePicker
                  label="End Time"
                  name='finishTime'
                  format={datetimeFormat}
                  value={selectedShift?.finishTime ? dayjs(selectedShift?.finishTime) : null}
                  onChange={(newValue) => {
                    setSelectedShift({
                      ...selectedShift,
                      finishTime: newValue ? newValue.format('YYYY-MM-DDTHH:mm:ss') : null
                    });
                  }}
                  slotProps={{ textField: { variant: "outlined" } }}
                  sx={{ pt: 1 }}
                />
              </LocalizationProvider>

              <Button
                onClick={handleSaveShiftInfo}
                sx={{ ml: 1, mt: 1, background: 'var(--template-palette-action-selected)' }} >
                {shiftEditMode ? 'Update Shift' : 'Add Shift'}
              </Button>
            </Box>
          )}

          <ConfirmDialog
            open={confirmDelete.open}
            onClose={handleCloseDeleteDialog}
            title="Confirm Deletion"
            cancelLabel="Cancel"
            cancelAction={handleCloseDeleteDialog}
            confirmLabel="Confirm"
            confirmAction={handleConfirmDelete}
          >
            <p>Are you sure you want to delete this shift?</p>
          </ConfirmDialog>

          <ConfirmDialog
            open={confirmDeassign.open}
            onClose={handleCloseDeassignDialog}
            title="Confirm Task Deassignation"
            cancelLabel="Cancel"
            cancelAction={handleCloseDeassignDialog}
            confirmLabel="Confirm"
            confirmAction={handleConfirmDeassign}
          >
            <p>Are you sure you want to deassign this task?</p>
          </ConfirmDialog>

          <ConfirmDialog
            open={confirmMainClose}
            onClose={handleCancelSaveDialog}
            title="Confirm Window Close"
            cancelLabel="Cancel"
            cancelAction={handleCancelSaveDialog}
            confirmLabel="Confirm Close"
            confirmAction={handleConfirmSaveDialog}
          >
            <p>You updated some shifts. You should Save first or Close to lose all changes.</p>
          </ConfirmDialog>
        </CustomTabPanel>
        <CustomTabPanel index={1} value={tabsValue}>
          <Typography
            component="h1"
            variant="subtitle1"
            sx={{
              pt: 1,
              pr: 4
            }}
          >Patrol Audit Entries
          </Typography>

          {entity && <AuditGrid width="1" entityType='patrol' entityId={entity.id} />}
        </CustomTabPanel>

      </DialogContent>
      {tabsValue == 0 && <DialogActions sx={{ p: 3 }}>
        <Button onClick={onConfirmClose} color="secondary">
          Close
        </Button>
        {Boolean(fieldPermissions.shiftMgmt) &&
          <Button
            variant="contained"
            color="warning"
            sx={{
              color: '#ffffff'
            }}
            onClick={() => {
              handleSaveShifts();
              //onClose();
            }}
          >
            Save Shifts
          </Button>}
      </DialogActions>}
    </Dialog>
  );
}

